module.exports = __webpack_public_path__ + "img/gh-30292.asm.1446024c.jpg";